
















import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class Indicator extends Vue {
  private skipAnime: boolean = true

  private status: number = 0

  public change(n: number, skipAnime: boolean) {
    this.skipAnime = skipAnime
    this.status = n
  }

  get st(): string {
    switch (this.status) {
      case 0:
        return ''
      case 1:
        return this.skipAnime ? 'half' : 'half-anime'
      case 2:
        return this.skipAnime ? 'full' : 'full-anime'
    }
    return ''
  }
}
